export default __webpack_public_path__ + "static/media/johnlevengood2023capitalpride.b10f6bd8.jpg";